import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getAssetAttributes, getAssetRatingsAction, getAssetRatingsOddAction } from "../../actions/assetAttributesActions";
import { getEnumeration } from '../../actions/CommonAction';
import { getPrimaryAnalyst } from "../../actions/assetDetailsActions";
import { UrlPath } from "../../../config/routeConfig";
import { getAssetRatings, deleteAssetRatings, insertUpdateAssetRatings, getPrimaryAnalystDdl } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer, toast } from 'react-toastify';
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBADropDown } from "../../UiComponents/SBADropDown";
import { Modal } from "react-bootstrap";
import "./Details.css";
import { AgGridReact } from "ag-grid-react";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { CurrencyFormat } from "../../utils/currencyFormattter";
import { getPercentageValueFormat } from "../../utils/conversionMethods";
const blankAttribute = {
  "AssetId": 0,
  "AssetAttributeId": 0,
  "AssetAttributeHFId": 0,
  "AssetAttributePEId": 0,
  "AssetAttributeMSId": 0,
  "AssetFamilyId": 0,
  "AssetFamily": "",
  "ChartOfAccountId": 0,
  "ChartOfAccount": "",
  "OperatingCurrencyId": 0,
  "OperatingCurrency": "",
  "LegalStructureId": 0,
  "LegalStructure": "",
  "DomicileCountryId": 0,
  "DomicileCountry": "",
  "QuarterlyLetter": false,
  "AssetSecurityTypeId": 0,
  "AssetSecurityType": "",
  "AuditCompletionDate": null,
  "InvestmentTypeId": 0,
  "InvestmentType": "",
  "InvestmentPack": false,
  "AssetFactSheet": false,
  "AllowsSidePocket": false,
  "InvestsInOtherFundsId": 0,
  "InvestsInOtherFunds": "",
  "ExposureReportFrequencyId": 0,
  "ExposureReportFrequency": "",
  "PersonalCapital": "0",
  "AccceptsManagedAccounts": false,
  "InvestsInManagedAccount": false,
  "TradingCity": "",
  "ProhibitsUSInvestors": false,
  "FilingStatusId": 0,
  "FilingStatus": "",
  "KeyMan": false,
  "InvestorLetterFrequencyId": 0,
  "InvestorLetterFrequency": "",
  "PerfEstimateFrequencyId": 0,
  "PerfEstimateFrequency": "",
  "BloombergId": "",
  "ReportingFrequencyId": 0,
  "ReportingFrequency": "",
  "FiscalYear": null,
  "TaxId": "",
  "CIMAId": "",
  "FormDNumber": "",
  "VintageYear": null,
  "TargetFundRaise": 0,
  "EstimatedFirstCloseDate": null,
  "EstimatedFirstCloseAmount": 0,
  "EstimatedSecondCloseDate": null,
  "EstimatedSecondCloseAmount": 0,
  "OfferCoInvestment": false,
  "SingleDealFund": false,
  "ContinuationFund": false,
  "IssuerId": 0,
  "Issuer": "",
  "SharesOutstanding": 0,
  "CUSIP": "",
  "ISIN": "",
  "ManagementFee": 0,
  "FundFeeExpenses": 0,
  "OtherExpenses": 0,
  "ExpenseRatio": 0,
  "DistributionFrequencyId": 0,
  "DistributionFrequency": "",
  "IsMarketable": false,
  "ModifiedBy": 0
};
export const AssetAttributes = ({options}) => {

  const params = useParams();
  const hist = useNavigate();
  const Gstate = useSelector((state) => { return state; }) || {};
  const dispatch = useDispatch();
  const currentAsset = Gstate.asset.asset || {};
  const Attributes = Gstate.attributesDetails.attributesDetails || [];
  const isEditable = Gstate.authorizationData.isEditable;
  const ratingIdd = Gstate.AttributesRating.AttributesRating || [];;
  const ratingOdd = Gstate.AttributesOddRating.AttributesOddRating || [];
  //const assetRating = Gstate.AttributesRating.AttributesRating;
  const primaryanalyst = Gstate.primaryAnalyst.primaryAnalyst;
  const Enumerationdata = Gstate.enumValues.enumValues || [];
  const [showDrawer, setshowDrawer] = useState(false);
  const [newratingtype, setNewRatingtype] = useState([]);
  const [newAnalyst, setNewAnalyst] = useState([]);
  const [newRating, setNewRating] = useState([]);
  const [newDate, setNewDate] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [deleteratingid, setDeleteratingid] = useState([]);
  const [ratingIddGrid, setRatingIddGrid] = useState([]);
  useEffect(() => {
    // Filter the data after a timeout of 2000 milliseconds (2 seconds)
    setTimeout(() => {
      const filteredData = ratingIdd?.filter(item => item.RatingUsername !== 'Avg');
      setRatingIddGrid(filteredData);
    }, 100);
  }, [ratingIdd]);
  //const ratingIddGrid = ratingIdd?.filter(item => item.RatingUsername !== "Avg")
  const [ratingOddGrid, setRatingOddGrid] = useState([]);
  useEffect(() => {
    // Filter the data after a timeout of 2000 milliseconds (2 seconds)
    setTimeout(() => {
      const filteredData = ratingOdd?.filter(item => item.RatingUsername !== "Avg");
      setRatingOddGrid(filteredData);
    }, 100);
  }, [ratingOdd]);
  //const ratingOddGrid = ratingOdd?.filter(item => item.RatingUsername !== "Avg")


  const [editAssetratingid, SetEditAssetratingid] = useState(0);

  useEffect(() => {
    document.title = "Asset Details";
    if(params.Asset)
    {
      dispatch(getAssetAttributes(params.Asset));
      //  setTimeout(() => {
      //   dispatch(getAssetRatingsAction(params.Asset));
      //   dispatch(getAssetRatingsOddAction(params.Asset));
      // }, 100);
      dispatch(getAssetRatingsAction(params.Asset));
      dispatch(getAssetRatingsOddAction(params.Asset));
    }
  
    dispatch(getPrimaryAnalyst());
    dispatch(getEnumeration("AssetRatings"));
  }, [params]);

  const closeModal = () => {
    setshowDrawer(false);
    setShowModal(false);
  };
  const onDeleteButtonClick = () => {
    sbaAxios({
      url: `${deleteAssetRatings}${deleteratingid}`,
      method: 'get',
    }).then(() => {
      setShowModal(false);
      SBNotify({ Msg: "Selected Ratings Deleted Successfully", type: "success" });
      dispatch(getAssetRatingsAction(params.Asset));
      dispatch(getAssetRatingsOddAction(params.Asset));
    }).catch(() => {
      SBNotify({ Msg: "sone error  occured", type: "error" });
    })
  };
  const primaryAnalystDropdownChange = (e) => {
    setNewAnalyst(e.value);
  };
  const ratingEnumchange = (e) => {
    setNewRating(e.value);
  };
  const RatingDateChange = (newDate) => {
    setNewDate(newDate);
  };
  const Saverating = () => {
    let ifsave = true;
    const savedata = {
      assetRatingId: editAssetratingid !== 0 ? editAssetratingid : 0,
      assetRatingTypeId: newratingtype === "IDD" ? 1 : 2,
      assetRatingType: newratingtype,
      assetId: params.Asset,
      ratingUserId: newAnalyst.UserId,
      ratingUsername: newAnalyst.AnalystName,
      ratingLetter: newRating.EnumName,
      ratingValue: newRating.EnumValue,
      ratingDate: newDate,
      modifiedBy: 0
    }
    if (newAnalyst.AnalystName === "--Please Select--" || newAnalyst.UserId === -1) {
      ifsave = false;
      SBNotify({ Msg: " Please Select AnalystName ", type: "error" });
    }

    if (ifsave) {
      sbaAxios({
        url: `${insertUpdateAssetRatings}`,
        method: "post",
        data: savedata,
      }).then((response) => {
        setshowDrawer(false);
        SBNotify({ Msg: "Ratings Insert / Update Successfully", type: "success" });
        if (newratingtype === "IDD") {
          dispatch(getAssetRatingsAction(params.Asset));
        }
        else if (newratingtype === "ODD") {
          dispatch(getAssetRatingsOddAction(params.Asset));
        }

      }).catch((error) => {
        SBNotify({ Msg: "sone error  occured", type: "error" });
      });
    }

  };
  const onEditButtonClick = (Editdataops) => {
    setNewRatingtype(Editdataops.AssetRatingTypeId === 1 ? "IDD" : "ODD")
    setNewAnalyst({ "AnalystName": Editdataops.RatingUsername, "UserId": Editdataops.RatingUserId })
    setNewRating({ "EnumName": Editdataops.RatingLetter, "EnumValue": Editdataops.RatingValue });
    SetEditAssetratingid(Editdataops.AssetRatingId);
    setNewDate(Editdataops?.RatingDate ? moment(Editdataops?.RatingDate) : null);
    setshowDrawer(true);
  };
  const EditButtonRenderer = (props) => {

    const Editdata = props.data;
    const handleEditClick = () => {

      onEditButtonClick(Editdata);
    }
    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
          onClick={handleEditClick}
        ></i>
      </div>
    );

  }
  const DeleteButtonRenderer = (props) => {
    const ratingsid = props.data.AssetRatingId;

    const handleDeleteClick = () => {
      setShowModal(true);
      setDeleteratingid(ratingsid);
    }

    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={handleDeleteClick}
        ></i>
      </div>
    );
  };

  const onAddButtonClick = (data) => {
    setNewRatingtype(data)
    SetEditAssetratingid(0);
    setNewAnalyst({ "AnalystName": "--Please Select--", "UserId": -1 })
    setNewRating({ "EnumName": "--Please Select--", "EnumValue": -1 });
    setNewDate(new Date());
    setshowDrawer(true);

  };
  const RatingColumnDef = [
    {
      headerName: "Analyst", field: "RatingUsername", width: "100"
    },
    { headerName: "Ratings", field: "RatingLetter", width: "50" },
    {
      headerName: "Date", field: "RatingDate",
      valueFormatter: (params) => {
        return moment(params.value).format("MM/DD/YYYY");
      },
    },
    {
      headerName: "Edit",
      field: "Edit",
      maxWidth: 100,
      cellRenderer: EditButtonRenderer,
    },
    {
      headerName: "Delete",
      field: "Delete",
      maxWidth: 100,
      cellRenderer: DeleteButtonRenderer,
    },

  ];

  const defaultColDef = {
    sortable: false,
    filter: false,
    suppressMovable: true,
    flex: 1,
    resizable:true
  };

  return (
    <>
      <div className="row m-0" style={{ margintop: "-5px" }}>
        <form>
          <div className="col-lg-12  d-flex my-2">
            <div className="col-md-12 mb-4">
              <div className="d-flex justify-content-end">
                <Link
                  title="Click to edit Details"
                  className={
                    isEditable
                      ? "position-absolute edit_iconPH"
                      : " position-absolute edit_iconPH disabledControl"
                  }
                  to={
                    isEditable &&
                    `${UrlPath.AssetAttributesEdit}${params.Asset}`
                  }
                >
                  <i class="fa-solid fa-pencil edit_icon"></i>
                </Link>
              </div>
            </div>
          </div>
        </form>
        <br />
        <AttributesTab />
        <div className="col-lg-12 p-3 d-flex">
          <div className="col-md-12 d-flex gap-2">
            <div className="col-lg-12">
              <div class="row detail  m-0 ">
                <div class="row" style={{ marginTop: "20px" }}>
                  <p>Ratings</p>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="w-100 d-flex justify-content-between">
                      <p className="ms-4"> IDD - {ratingIdd[0]?.RatingLetter} {ratingIdd[0]?.RatingUsername} </p>
                      <button type="submit" className="p-sm-btn mx-1" onClick={() => onAddButtonClick('IDD')} ><i className="fa-solid fa-plus" /> Add</button>
                    </div>

                    <div className="ag-theme-alpine m-1" style={{ height: 350, width: '100%', marginRight: '10px' }}>
                      <AgGridReact
                        columnDefs={RatingColumnDef}
                        rowData={ratingIddGrid}
                        defaultColDef={defaultColDef}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="w-100 d-flex justify-content-between">
                      <p className="ms-4"> ODD - {ratingOdd[0]?.RatingLetter} {ratingOdd[0]?.RatingUsername}</p>
                      <button type="submit" className="p-sm-btn mx-1" onClick={() => onAddButtonClick('ODD')}  ><i className="fa-solid fa-plus" /> Add</button>
                    </div>
                    <div className="ag-theme-alpine m-1" style={{ height: 350, width: '100%', marginLeft: '10px' }}>
                      <AgGridReact
                        columnDefs={RatingColumnDef}
                        rowData={ratingOddGrid}
                        defaultColDef={defaultColDef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SBADrawer open={showDrawer} setOpen={setshowDrawer} close={false} title={'Add / Update  Ratings'}>
        <div>
          <div>
            <label className="header-container m-1">
              <b>Rating Type</b>
            </label>
            <div>
              <input
                className="form-control w-75"
                type="text"
                value={newratingtype}
                onChange={(e) => setNewRatingtype(e.target.value)}
                disabled
              />
            </div>
            <br></br>
            <label className="header-container m-1">
              <b>Analyst</b>
            </label>
            <div>
              <div>
                <SBADropDown
                  className="w-75"
                  textField={"AnalystName"}
                  valueField={"UserId"}
                  data={primaryanalyst}
                  onChange={primaryAnalystDropdownChange}
                  popupSettings={{ className: 'modalDD' }}
                  value={newAnalyst}
                />
              </div>
            </div>
            <br></br>
            <label className="header-container m-1">
              <b>Rating</b>
            </label>
            <div>



              <SBADropDown
                className="w-75"
                textField={"EnumName"}
                valueField={"EnumValue"}
                data={Enumerationdata.filter(item=>item.EnumName!=="N/A")}
                onChange={ratingEnumchange}
                popupSettings={{ className: 'modalDD' }}
                value={newRating}
              />

            </div>
            <br></br>
            <label className="header-container m-1">
              <b>Date</b>
            </label>
            <div>
              <SBDatePicker
                className="w-75"
                id="eventDate"
                defaultValue={newDate ? moment(newDate) : null}
                onChange={RatingDateChange}
              />
            </div>

            <br></br>
          </div>
          <div className="mt-4">
            <button className="s-sm-btn mx-1" onClick={closeModal}>
              Cancel
            </button>
            <button className="p-sm-btn mx-1" onClick={Saverating}>
              Save
            </button>
          </div>
        </div>
      </SBADrawer >
      {<Modal show={showModal}  >
        <Modal.Header closeButton onClick={closeModal}>
          <Modal.Title>Do you want to delete the selected Ratings?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The selected Ratings will be deleted permanently. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
          <button className='p-sm-btn mx-1' onClick={onDeleteButtonClick} >
            Yes
          </button>
        </Modal.Footer>
      </Modal>}
    </>
  );
};
export const AttributesTab = () => {

  const HF=[1 ,11 ,12];
  const PE=[2 ,5 ,13, 18 ,19 ,20];

  const Gstate = useSelector((state) => { return state; }) || {};

  const currentAsset = Gstate.asset.asset || {};
  const AssetType = currentAsset?.SecurityTypeId || 0;

  const Attributes = Gstate.attributesDetails.attributesDetails || {};
  const isLoading = Gstate.attributesDetails.isAssetAttributeLoading;

  const [attribute, setAttribute] = useState(blankAttribute);
  const [tabLoading, setTabLoading] = useState(true);

  useEffect(() => {
    setAttribute(Attributes);
    setTabLoading(isLoading);
  }, [isLoading, Attributes,currentAsset]);
  return <>
  {!tabLoading ? <>
    {attribute.IsMarketable  && <MSLayout Attribute={attribute} />} 
    {PE.includes(AssetType)  && <PELayout attribute={attribute} />} 
    {HF.includes(AssetType)  && <HFLayout attribute={attribute} />} 
  </> : <><LoadingScreen/></>
}
</>
};
export const MSLayout = ({ Attribute }) => {
  const [attribute,setAttribute]=useState(Attribute);
  useEffect(()=>{
    setAttribute(Attribute);
  },[Attribute])

  return <>
    <div className="row ">
      <div className="col-sm-8">
        <div class="row detail m-0  p-3">
          <div class="row ">
            <p>Legal</p>
          </div>
          <div class="row mb-3">
           <LabelViewer Value={attribute?.Issuer} name={"Issuer"} colLength={"col-sm-4"} />
           <LabelViewer Value={attribute?.TradingCity} name={"Trading City"} colLength={"col-sm-4"} />    
            <LabelViewer Value={getPercentageValueFormat(attribute?.ManagementFee)} name={"Management Fee"} colLength={"col-sm-4"} />
          </div>
                  <div class="row mb-3">
                      <LabelViewer Value={attribute?.BloombergId} name={"Ticker"} colLength={"col-sm-4"} />
                      <LabelViewer Value={attribute?.AuditCompletionDate} name={"Audit Completion Date"} colLength={"col-sm-4"} type={"Date"} />         
                      <LabelViewer Value={getPercentageValueFormat(attribute?.FundFeeExpenses)} name={"Fund Fees and Expenses"} colLength={"col-sm-4"} />
                  </div>
                  <div class="row mb-3">
                      <LabelViewer Value={attribute?.FiscalYear} name={"Fiscal Year End"} colLength={"col-sm-4"} type={"Date"} />
                      <LabelViewer Value={attribute?.ReportingFrequency} name={"Reporting Frequency"} colLength={"col-sm-4"} />
                      <LabelViewer Value={getPercentageValueFormat(attribute?.OtherExpenses)} name={"Other Expenses"} colLength={"col-sm-4"} />

                  </div>

          <div class="row mb-3">
            <LabelViewer Value={attribute?.LegalStructure} name={"Legal Structure"} colLength={"col-sm-4"} />
                      <LabelViewer Value={attribute?.CUSIP} name={"CUSIP"} colLength={"col-sm-4"} />
                      <LabelViewer Value={getPercentageValueFormat(attribute?.ExpenseRatio)} name={"Expense Ratio"} colLength={"col-sm-4"} />
          
          </div>
          <div class="row mb-3">
            <LabelViewer Value={attribute?.OperatingCurrency} name={"Operating Currency"} colLength={"col-sm-4"} />
                      <LabelViewer Value={attribute?.ISIN} name={"ISIN"} colLength={"col-sm-4"} />
                      <LabelViewer Value={attribute?.DistributionFrequency} name={"Distribution Frequency"} colLength={"col-sm-4"} />
          
          </div>
          <div class="row mb-3">
            <LabelViewer Value={attribute?.DomicileCountry} name={"Domicile Country"} colLength={"col-sm-4"} />
            <LabelViewer Value={attribute?.SharesOutstanding} name={"Shares Outstanding"} colLength={"col-sm-4"} />
            <CheckViewer Value={attribute?.IsClientSpecific} name={"Client Specific"} colLength={"col-sm-4"} />
          </div>
          
        </div>
      </div>
    </div>
  </>
};
export const PELayout = ({ attribute }) => {
  return <>
    <div className="row ">
      <div className="col-sm-8">
        <div class="row detail m-0  p-3">
          <div class="row ">
            <p>Legal</p>
          </div>
          <div class="row mb-3">
                      <LabelViewer Value={attribute?.VintageYear} name={"Vintage Year"} colLength={"col-sm-4"} type={"Date"} />
                      <LabelViewer Value={attribute?.TradingCity} name={"Trading City"} colLength={"col-sm-4"} />
            <LabelViewer Value={CurrencyFormat(attribute?.TargetFundRaise)} name={"Target Fund Raise"} colLength={"col-sm-4"} />
           
                  </div>
                  <div class="row mb-3">
                      <LabelViewer Value={attribute?.BloombergId} name={"Ticker"} colLength={"col-sm-4"} />
                      <LabelViewer Value={attribute?.AuditCompletionDate} name={"Audit  Completion Date"} colLength={"col-sm-4"} type={"Date"} />
                      <LabelViewer Value={attribute?.FiscalYear} name={"Fiscal Year End Date"} colLength={"col-sm-4"} type={"Date"} />

                  </div>
          <div class="row mb-3">
            <LabelViewer Value={attribute?.LegalStructure} name={"Legal Structure"} colLength={"col-sm-4"} />
            <LabelViewer Value={attribute?.EstimatedFirstCloseDate} name={"Estimated First Close Date"} colLength={"col-sm-4"} type={"Date"} />
            <CheckViewer Value={attribute?.SingleDealFund} name={"Single Deal Fund"} colLength={"col-sm-4"} />
          </div>
          <div class="row mb-3">
            <LabelViewer Value={attribute?.OperatingCurrency} name={"Operation Currency "} colLength={"col-sm-4"} />
            <LabelViewer Value={CurrencyFormat(attribute?.EstimatedFirstCloseAmount)} name={"Estimated First Close Amount"} colLength={"col-sm-4"} />
             <CheckViewer Value={attribute?.ContinuationFund} name={"Continuation Fund"} colLength={"col-sm-4"} />
          </div>
          <div class="row mb-3">
            <LabelViewer Value={attribute?.DomicileCountry} name={"Domicile Country"} colLength={"col-sm-4"} />
            <LabelViewer Value={attribute?.EstimatedSecondCloseDate} name={"Estimated Second Close Date"} colLength={"col-sm-4"} type={"Date"} />
           <CheckViewer Value={attribute?.OfferCoInvestment} name={"Offer Co-Investment"} colLength={"col-sm-4"} />
          </div>
          <div class="row mb-3">
           
            <LabelViewer Value={CurrencyFormat(attribute?.EstimatedSecondCloseAmount)} name={"Estimated Second Close Amount"} colLength={"col-sm-4"} />
            <CheckViewer Value={attribute?.IsClientSpecific} name={"Client Specific"} colLength={"col-sm-4"} />
           
          </div>
        </div>
      </div>
      <ReportingSection attribute={attribute}/>
    </div>
  </>
};
export const HFLayout = ({ attribute }) => {
  return <>
    <div className="row">
      <div className="col-sm-8">
        <div class="row detail m-0  p-3">
          <div class="row ">
            <p>Legal</p>
          </div>
          <div class="row mb-3">
            {/* <LabelViewer Value={attribute?.inceptionDate} name={"Inception Date"} colLength={"col-sm-4"} type={"Date"} /> */}
                      <LabelViewer Value={attribute?.LegalStructure} name={"Legal Structure"} colLength={"col-sm-4"} />
                      <LabelViewer Value={attribute?.TradingCity} name={"Trading City"} colLength={"col-sm-4"} />
                       <CheckViewer Value={attribute?.ProhibitsUSInvestors} name={"Prohibits US Investor"} colLength={"col-sm-4"} />
                  </div>
                  <div class="row mb-3">
                      <LabelViewer Value={attribute?.BloombergId} name={"Ticker"} colLength={"col-sm-4"} />
                      <LabelViewer Value={attribute?.AuditCompletionDate} name={"Audit Completion Date"} colLength={"col-sm-4"} type={"Date"} />
                      <CheckViewer Value={attribute?.AccceptsManagedAccounts} name={"Accepts Managed Accounts"} colLength={"col-sm-4"} />
                  </div>
          <div class="row mb-3">
          <LabelViewer Value={attribute?.OperatingCurrency} name={"Operation Currency "} colLength={"col-sm-4"} />
            {/* <LabelViewer Value={attribute?.LegalStructure} name={"legal Structure"} colLength={"col-sm-4"}  /> */}
                      <LabelViewer Value={attribute?.FormDNumber} name={"FromD Number"} colLength={"col-sm-4"} />
                      <CheckViewer Value={attribute?.AllowsSidePocket} name={"Allow Side Pocket"} colLength={"col-sm-4"} />
          </div>
          <div class="row mb-3">
            <LabelViewer Value={attribute?.FiscalYear} name={"Fiscal Year End Date"} colLength={"col-sm-4"} type={"Date"} />
            {/* <LabelViewer Value={attribute?.OperatingCurrency} name={"Operation Currency "} colLength={"col-sm-4"} /> */}
                      <LabelViewer Value={attribute?.FilingStatus} name={"Filing Status"} colLength={"col-sm-4"} />
                      <CheckViewer Value={attribute?.InvestsInManagedAccount} name={"Invests in Managed Accounts"} colLength={"col-sm-4"} />
          </div>
          <div class="row mb-3">
            <LabelViewer Value={attribute?.DomicileCountry} name={"Domicile Country"} colLength={"col-sm-4"} />
             <LabelViewer Value={attribute?.InvestsInOtherFunds} name={"Invests in Other Funds"} colLength={"col-sm-4"} />
             <CheckViewer Value={attribute?.KeyMan} name={"Key Man"} colLength={"col-sm-4"} />
          </div>
          <div class="row mb-3">
          <LabelViewer Value={attribute?.AssetFamily} name={"Asset Family"} colLength={"col-sm-4"} />
            {/* <LabelViewer Value={attribute?.TradingCity} name={"Trading City"} colLength={"col-sm-4"} /> */}
            <CheckViewer Value={attribute?.IsClientSpecific} name={"Client Specific"} colLength={"col-sm-4"} />
           
          </div>
          {/* <div class="row mb-3">
            <LabelViewer Value={attribute?.AssetFamily} name={"Asset Family"} colLength={"col-sm-4"} /> 
            <LabelViewer Value={false} name={""} colLength={"col-sm-4"} />
            <CheckViewer Value={attribute?.AllowsSidePocket} name={"Allow Side Pocket"} colLength={"col-sm-4"} />
          </div> */}
        </div>
      </div>
      <ReportingSection attribute={attribute}/>
    </div>
  </>
};
const ReportingSection=({attribute})=>{
  return <> <div className="col-sm-4">
  <div class="detail m-0  p-3">
    <div class="row ">
      <p>Reporting</p>
    </div>
    <div class="row mb-3">
      <LabelViewer Value={attribute?.InvestorLetterFrequency} name={"Letter to Investor Frequency"} colLength={"col-sm-4"} />
      <LabelViewer Value={attribute?.AssetSecurityType} name={"Asset Type "} colLength={"col-sm-4"} />
    </div>
    <div class="row mb-3">
      <CheckViewer Value={attribute?.QuarterlyLetter} name={"Quarterly Letter"} colLength={"col-sm-4"} />
      <CheckViewer Value={attribute?.AssetFactSheet} name={"Fact Sheet"} colLength={"col-sm-4"}  />
    </div>
    <div class="row mb-3">
      <LabelViewer Value={attribute?.ReportingFrequency} name={"Reporting Frequency "} colLength={"col-sm-4"} />
      <CheckViewer Value={attribute?.InvestmentPack} name={"Investment Pack"} colLength={"col-sm-4"} />
    </div>
    <div class="row mb-3">
      <LabelViewer Value={attribute?.PerfEstimateFrequency} name={"Performance Estimate Frequency"} colLength={"col-sm-4"} />
      <LabelViewer Value={attribute?.InvestmentType} name={"Investment Type"} colLength={"col-sm-4"} />
    </div>
    <div class="row mb-3">
      <LabelViewer Value={attribute?.ExposureReportFrequency} name={"Exposure Report Frequecy"} colLength={"col-sm-4"} />
      <LabelViewer Value={CurrencyFormat(attribute?.PersonalCapital ? parseInt(attribute?.PersonalCapital) : 0)} name={"Personal Captial"} colLength={"col-sm-4"} />
    </div>
  </div>
</div>
  </>
}
const LabelViewer = ({ name, Value, colLength ,type }) => {
  const [labelName, setLabelName] = useState(name);
  const [labelValue, setLabelValue] = useState(Value);

  useEffect(() => {
    setLabelName(name);
    setLabelValue(Value);
  }, [name, Value])
  return <>
    <div className={colLength}>
      {labelName && <> <span className="fw-medium">{labelName}</span>
      <>
      {type==="Date" ? <p className="fw-medium mb-0"> {labelValue  ? moment(labelValue).format("MM/DD/YYYY") : "NA"}</p> :  
      <p className="fw-medium mb-0"> {labelValue  ? labelValue : "NA"}</p>}
      </> 
      </> }
    </div>
  </>
};
const CheckViewer = ({ colLength, Value, name }) => {
  const [labelName, setLabelName] = useState(name);
  const [checked, setChecked] = useState(Value);

  useEffect(() => {
    setLabelName(name);
    setChecked(Value);
  }, [name, Value]);

  return <div class={colLength}>
    <label
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <input
        className="me-1"
        type="checkbox"
        checked={checked}
      />
      <span className="fw-medium">{labelName}</span>
    </label>
  </div>
};
